import React, { forwardRef } from 'react';
import classNames from 'classnames';

import './_tabs-pills.item.scss'
import './_tabs-pills.item.dark-mode.scss'
import PropTypes from 'prop-types';

import { UI_NAME } from '../../../utils/config';

const TabsPillsItem = forwardRef((props, ref) => {
  const { className, active, size, disabled, children, ...rest } = props;
  const { onClick, ...otherRest } = rest;

  const handleClick = (event) => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <div
      className={classNames(
        `${UI_NAME}-tabs-pills__item`,
        className,
        {
          [`${UI_NAME}-tabs-pills__item--active`]: active,
          [`${UI_NAME}-tabs-pills__item--disabled`]: disabled,
          [`${UI_NAME}-tabs-pills__item--size-md`]: size === 'md',
        },
      )}
      ref={ref}
      onClick={handleClick}
      {...otherRest}
    >
      {children}
    </div>
  )
});

TabsPillsItem.defaultProps = {
  size: 'md',
  disabled: false,
}

TabsPillsItem.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
}

export default TabsPillsItem;
